import React from 'react';
import Imgix from "react-imgix";
import { IFilterItem } from '../interfaces';
import Divider from './divider';
import { isMobile } from '../../../../domain/common';
import { sendGAEvent } from '../../../../domain/marketing/gtm-provider';
import { useAppSelector } from '../data/store';

interface ISearchItemProps {
    filterItem: IFilterItem;
    position: number;
    isLast: boolean;
}

const isMobileScreen = isMobile();

const SearchItem = (props : ISearchItemProps) => {

    const { filterItem, position, isLast } = props;

    const query = useAppSelector(store => store.root.query);

    const imgAbsPath = `https://media.wavescdn.com${ filterItem.tiny }`;

    const sendClickGAEvent = () => {
        // q: {query} | pos: {position} | page: {distinationURL}
        // q: api | pos: 3 | page: /plugins/api-2500
        sendGAEvent('SQLSearchClick', `q: ${ query.toLowerCase() } | pos: ${ position  + 1 } | page: ${ filterItem.documentUrlPath }`);
    };

    return (
        <div className="w-full pt-2">

            <div className="flex items-center justify-center">

                <a
                    className="md:pr-6 md:w-auto"
                    href={ filterItem.documentUrlPath }
                    onClick={ sendClickGAEvent }
                    rel="noreferrer">
                    {
                        filterItem.tiny &&
                        <Imgix
                            className="p-4 md:p-2"
                            src={ imgAbsPath }
                            width={isMobileScreen ?  120 : 180 }
                            htmlAttributes={{
                                alt: `Image for ${ filterItem.documentName }`,
                                loading: 'lazy',
                            }}
                            disableQualityByDPR
                        />
                    }
                </a>

                <div className="flex-1">
                    <div className="font-bold text-base md:text-lg p-1">
                        <a
                            className="no-underline text-black"
                            href={ filterItem.documentUrlPath }
                            onClick={ sendClickGAEvent }
                            rel="noreferrer">
                            { filterItem.documentName }
                        </a>
                    </div>

                    <div className={`w-full p-1 w-ellipsis w-line-clamp-2`} dangerouslySetInnerHTML={{__html: filterItem.documentPageDescription }} />

                    <div className="hidden md:block w-full p-1" >
                        <a
                            href={ filterItem.documentUrlPath }
                            onClick={ sendClickGAEvent }
                            rel="noreferrer">
                            https://{ window.location.host }{ filterItem.documentUrlPath }
                        </a>
                    </div>
                </div>
            </div>

            {!isLast && <Divider /> }

        </div>


    )
};

export default SearchItem;